import { useTranslation } from 'next-i18next';
import Image from 'src/components/Image';
interface Props {
  className?: string;
}
export default function VividiLogo({
  className
}: Props) {
  const {
    t
  } = useTranslation();
  return <Image src='/vividi/images/logo/logo.png' alt={t('Vividi')} className={className} data-sentry-element="Image" data-sentry-component="VividiLogo" data-sentry-source-file="index.tsx" />;
}